import { put, takeEvery } from '@zaibot/fsa-saga';
import { fork, select } from '../../redux-saga';
import { bookmarksBatch, bookmarksEditor, bookmarksResource } from './resource';

import { selectors as metaSelectors } from '../../meta/selectors';

import AUTHENTICATED from '../../auth/actions/AUTHENTICATED';
import LOGGEDOUT from '../../auth/actions/LOGGEDOUT';
import { SelectEffect } from 'redux-saga/effects';

export function* rootSaga(): Iterable<any> {
    yield fork(bookmarksResource.saga);
    yield fork(bookmarksEditor.saga);
    yield fork(bookmarksBatch.saga);
    yield fork(monitorSelectedBookmark);
    yield fork(signalBookmarksList);
    yield fork(signalBookmarksReset);
}

function* monitorSelectedBookmark() {
    yield takeEvery(bookmarksEditor.actions.READ, function*(action) {
        const pageIdEff: SelectEffect = yield select(metaSelectors.pageId);
        const pageId: any = pageIdEff;
        if (action.payload.item.pageId !== pageId) {
            window.location.href = action.payload.item.url;
        }
    });
}

function* signalBookmarksList() {
    yield takeEvery(AUTHENTICATED, function*() {
        let selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        let selectionDocumentId: any = selectionDocument;
        yield put(bookmarksResource.actions.LIST({ params: { selectionDocumentId } }));
    });
}

function* signalBookmarksReset() {
    yield takeEvery(LOGGEDOUT, function*() {
        yield put(bookmarksEditor.actions.RESET({ }));
        yield put(bookmarksResource.actions.RESET({ }));
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/bookmarks/sagas.tsx